export const mail = {
  '站内信': 'Внутренние сообщения',
  '返回': 'Назад',
  '有未读信息': '{amount} непрочитанных сообщений',
  '全部标记为已读': 'Отметить все как прочитанные',
  '隐藏已读消息': 'Скрыть прочитанные',
  '展开': 'Развернуть',
};


// WEBPACK FOOTER //
// ./src/i18n/lang/mail/ru.js